var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"text-view"},[_c('b-col',{staticClass:"mr-0 pl-0 d-flex justify-content-start align-item-start",attrs:{"cols":"2"}},[_c('label',[_vm._v(_vm._s(_vm.label))])]),_c('b-col',{staticClass:"ml-0 mb-1 pr-0 d-flex justify-content-start align-item-start"},[_c('p',[_vm._v(_vm._s(_vm.value))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }